




























import { defineComponent, toRefs, PropType, computed } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import Ios14Info from './index';
import { usePropsIos14Quota } from './../../ios14-switch/hooks';
import { useSelectedApp } from './../../../hooks/creation/adgroup/useSelectedApp/index';
import { NetStateEnum, StateEnum, useStore, useStdAdgroupIs } from '@tt4b/ttam-hooks';

const name = 'ttam-ios14-info-compose';
export default defineComponent({
  name,
  components: {
    TtamIos14InfoPolicyInfo: Ios14Info.TtamIos14InfoPolicyInfo,
    TtamIos14InfoQuotaCard: Ios14Info.TtamIos14InfoQuotaCard,
    TtamIos14InfoQuotaDetailCampaign: Ios14Info.TtamIos14InfoQuotaDetailCampaign,
    TtamIos14InfoQuotaDetailAdgroup: Ios14Info.TtamIos14InfoQuotaDetailAdgroup,
    TtamIos14InfoQuotaDetailCreative: Ios14Info.TtamIos14InfoQuotaDetailCreative,
    TtamIos14InfoQuotaDetailLimit: Ios14Info.TtamIos14InfoQuotaDetailLimit,
    TtamIos14InfoQuotaDetailSplitTest: Ios14Info.TtamIos14InfoQuotaDetailSplitTest,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
  },
  setup(props) {
    const { state } = useStore();
    const { campaignData, adgroupData } = toRefs(props);

    const { visible } = Ios14Info.usePropsVisible({
      adgroupData,
    });
    const { isOnlySupportTT } = useStdAdgroupIs({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
    });
    const ios14Quota = computed(() => state[StateEnum.ios14Quota].data.value);

    const isShowCreativeQuota = computed(() => ios14Quota.value?.creativeQuota?.totalQuota > 0);

    const { eventManagerUrl, appName } = useSelectedApp({
      adgroupData,
    });

    const { splitTestDetailVisible } = Ios14Info.usePropsSplitTestDetailVisible({ campaignData, adgroupData });

    return {
      name,
      ios14Quota,
      isShowCreativeQuota,
      eventManagerUrl,
      appName,
      visible,
      splitTestDetailVisible,
      isOnlySupportTT,
    };
  },
});
